export default __webpack_public_path__ + "static/media/cover (2).dd193923.svg";